import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { Client } from '../model';
import { Context } from '../../../types';

export default createContext<Context<Client>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: [],
    setData: noop,
    selected: {},
    setSelected: noop,
    error: null
});
